<!-- 柱状图 -->
<style lang="less" scoped>
.bar-wrap {
  width: 100%;
  height: 100%;
  overflow: hidden;
  ul {
    li {
      width: 250/19.2vw;
      height: 131/10.8vh;
      float: left;
      background: url("../../../../../assets/img/chaye/ul.png") no-repeat;
      background-size: 100% 100%;
      img {
        width: 50/10.8vh;
        height: 50/10.8vh;
        margin-top: 45/10.8vh;
        margin-left: 20/10.8vh;
        float: left;
        margin-right: 5/19.2vw;
      }
      p {
        display: inline-block;
      }
      p:nth-child(2) {
        margin-top: 30/10.8vh;
        font-size: 1.6vh;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(92, 178, 255, 1);
        line-height: 3vh;
      }
      p:nth-child(3) {
        font-size: 1.5vw;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(255, 248, 231, 1);
      }
    }
    li:nth-child(1) {
      background: url("../../../../../assets/img/chaye/li1.png") no-repeat;
      background-size: 100% 100%;
    }
    li:nth-child(2) {
      background: url("../../../../../assets/img/chaye/li2.png") no-repeat;
      background-size: 100% 100%;
    }
    li:nth-child(3) {
      background: url("../../../../../assets/img/chaye/li3.png") no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>

<template>
  <div class="bar-wrap">
    <ul>
      <li>
        <img src="../../../../../assets/img/chaye/icon1.png" />
        <p>可追溯商品数量</p>
        <p><countTo
          class="count"
          :startVal="1286708"
          :endVal="2286708"
          :duration="5000"
        ></countTo></p>
      </li>
      <li>
        <img src="../../../../../assets/img/chaye/icon2.png" />
        <p>累计扫码量</p>
        <p><countTo
          class="count"
          :startVal="10785098"
          :endVal="18785098"
          :duration="5000"
        ></countTo></p>
      </li>
      <li>
        <img src="../../../../../assets/img/chaye/icon3.png" />
        <p>区块链存证批次数量</p>
        <p><countTo
          class="count"
          :startVal="0"
          :endVal="62480"
          :duration="5000"
        ></countTo></p>
      </li>
      <li>
        <img src="../../../../../assets/img/chaye/icon4.png" />
        <p>区块链存证节点数量</p>
        <p><countTo
          class="count"
          :startVal="0"
          :endVal="1376682"
          :duration="5000"
        ></countTo></p>
      </li>
    </ul>
  </div>
</template>
<script>
import countTo from "vue-count-to";

export default {
  data() {
    return {
      name: "新生男女比例"
    };
  },
  components: {
    countTo
  },
  methods: {},
  async mounted() {}
};
</script>



// WEBPACK FOOTER //
// index.vue?4b6ca7de